export default {
  name: "Shylajee Ladies Tailoring and Training Institute",
  feedback: `Hi, iam Lakshmijagannathan, Salem cakecraft studio baking class gave me a amazing experience! .
  The instructor was knowledgeable, patient, and provided constructive feedback. 
  I learned various techniques, from basic to advanced, and enjoyed making delicious treats. 
  The classroom was well-equipped, and the atmosphere was friendly and supportive. 
  I highly recommend this class to anyone interested in baking!", 
  today exotic work shop classes make me more confidence in this field.
  Thankyou Ramya mam.🙏🏻`
};